import { render } from '@wordpress/element';
import FrontendApp from './App/FrontApp';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('dotfw_donation');

  if (root) {
    render(
        <FrontendApp />,
      	root
    );
  }
});
